import { useEffect } from "react";

const PaymentPage = () => {

  useEffect(() => {
    const startPayment = async () => {
      const email = localStorage.getItem("email");

      const res = await fetch("http://127.0.0.1:8000/api/event/create-checkout-session/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url; // 🔥 redirect to Stripe
      } else {
        alert("Payment initialization failed");
      }
    };

    startPayment();
  }, []);

  return <p>Redirecting to payment...</p>;
};

export default PaymentPage;